/* eslint-disable */
import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
import withStyles from '@mui/styles/withStyles';
// @mui/icons-material

// core components
import cardHeaderStyle from '../../assets/jss/material-dashboard-react/components/cardHeaderStyle';

type Props = {
  classes: any;
  className?: string;
  color?: 'warning' | 'success' | 'danger' | 'info' | 'primary' | 'rose';
  plain?: boolean;
  stats?: boolean;
  icon?: boolean;
  children: any;
};

function CardHeader({...props}: Props) {
  const {classes, className, children, color, plain, stats, icon, ...rest} =
    props;
  const cardHeaderClasses = classNames({
    [classes.cardHeader]: true,
    [classes[color + 'CardHeader']]: color,
    [classes.cardHeaderPlain]: plain,
    [classes.cardHeaderStats]: stats,
    [classes.cardHeaderIcon]: icon,
    // @ts-expect-error ts-migrate(2464) FIXME: A computed property name must be of type 'string',... Remove this comment to see the full error message
    [className]: className !== undefined,
  });
  return (
    <div className={cardHeaderClasses} {...rest}>
      {children}
    </div>
  );
}

export default withStyles(cardHeaderStyle)(CardHeader);
